<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="trafficClasses"
      :items="trafficClasses"
      :fields="trafficClassesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal
      @restoreEditItems="fillEditItems"
      :editItem="selectedTrafficClasses"
      :netflowList="netflowList"
      :isDisplay="isDisplay"
      :isFillin="isFillin"
      :isDontSave="isDontSave"
      :flagSkip="flagSkip"
      :isEdit="isEdit"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      arrMask: new Map([
        ['255.255.255.255', 32],
        ['255.255.255.254', 31],
        ['255.255.255.252', 30],
        ['255.255.255.248', 29],
        ['255.255.255.240', 28],
        ['255.255.255.224', 27],
        ['255.255.255.192', 26],
        ['255.255.255.128', 25],
        ['255.255.255.0', 24],
        ['255.255.254.0', 23],
        ['255.255.252.0', 22],
        ['255.255.248.0', 21],
        ['255.255.240.0', 20],
        ['255.255.224.0', 19],
        ['255.255.192.0', 18],
        ['255.255.128.0', 17],
        ['255.255.0.0', 16],
        ['255.254.0.0', 15],
        ['255.252.0.0', 14],
        ['255.248.0.0', 13],
        ['255.240.0.0', 12],
        ['255.224.0.0', 11],
        ['255.192.0.0', 10],
        ['255.128.0.0', 9],
        ['255.0.0.0', 8],
        ['254.0.0.0', 7],
        ['252.0.0.0', 6],
        ['248.0.0.0', 5],
        ['240.0.0.0', 4],
        ['224.0.0.0', 3],
        ['192.0.0.0', 2],
        ['128.0.0.0', 1],
        ['0.0.0.0', 0]
      ]),
      flagSkip: 1,
      isEdit: false,
      isDisplay: false,
      isFillin: false,
      isDontSave: false,
      trafficClassesFields: [
        {key: 'tclass_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'display', label: this.$i18n.t('Display'), sortable: true},
        {key: 'fillIn', label: this.$i18n.t('Fill in'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedTrafficClasses: {
        item: [],
        info: {
          name: '',
          flags: 0
        }
      },
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedTrafficClasses = {
        item: [],
        info: {
          color: '#000000',
          flags: 0,
          local_policy: 0,
          name: '',
          tclass_id: '',
          timerange_id: 0

        }
      }
      this.isEdit = false
      this.isDisplay = false
      this.isFillin = false
      this.isDontSave = false
      this.$root.$emit('bv::show::modal', 'modalEditTrafficClasses', '#btnShow')
    },
    fillEditItems () {
      this.selectedTrafficClasses = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TRAFFIC_CLASSES']))
      this.selectedTrafficClasses.info.color = '#' + (((2147483648 + this.selectedTrafficClasses.info.color).toString(16)).substr(2, 6))
      let num = 0
      for (let el of this.selectedTrafficClasses.item) {
        el.num = ++num
        if (el.nfprovider_id) {
          for (let elNetFlow of this.netflowList) {
            if (el.nfprovider_id === elNetFlow.provider_id) {
              el.ipNetflow = elNetFlow.ip_address
            }
          }
        }
        if (el.flags) {
          if (el.flags & this.flagSkip) {
            el.isSkip = true
          }
        }
        el.saddr_mask = this.arrMask.get(el.saddr_mask)
        el.daddr_mask = this.arrMask.get(el.daddr_mask)
        el.source = el.saddr + '/' + el.saddr_mask
        el.destination = el.daddr + '/' + el.daddr_mask
      }
      switch (this.selectedTrafficClasses.info.flags) {
        case 0:
          this.isDisplay = false
          this.isFillin = false
          this.isDontSave = false
          break
        case 1:
          this.isDisplay = false
          this.isFillin = true
          this.isDontSave = false
          break
        case 2:
          this.isDisplay = true
          this.isFillin = false
          this.isDontSave = false
          break
        case 3:
          this.isDisplay = true
          this.isFillin = true
          this.isDontSave = false
          break
        case 4:
          this.isDisplay = false
          this.isFillin = false
          this.isDontSave = true
          break
        case 5:
          this.isDisplay = false
          this.isFillin = true
          this.isDontSave = true
          break
        case 6:
          this.isDisplay = true
          this.isFillin = false
          this.isDontSave = true
          break
        case 7:
          this.isDisplay = true
          this.isFillin = true
          this.isDontSave = true
          break
      }
    },
    async editItem (item) {
      this.isEdit = true
      await this.$store.dispatch('Tariffing/GET_TRAFFIC_CLASSES', item.tclass_id).then(response => {
        this.selectedTrafficClasses = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TRAFFIC_CLASSES']))
      })
      this.fillEditItems()
      this.$root.$emit('bv::show::modal', 'modalEditTrafficClasses', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Traffic classes"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_TRAFFIC_CLASSES', item.tclass_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TRAFFIC_CLASSES_LIST')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    trafficClasses () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']))
      for (let el of copy) {
        if (el.flags === 1 || el.flags === 3) {
          el.fillIn = true
        }
        if (el.flags === 2 || el.flags === 3) {
          el.display = true
        }
      }
      return copy
    },
    netflowList () {
      let res = []
      for (let el of this.$store.getters['Settings/NETFLOW_PROVIDERS']) {
        let newEl = {}
        newEl.value = el.provider_id
        newEl.text = el.ip_address + ' (' + el.provider_id + ')'
        res.push(newEl)
      }
      res.push({value: 0, text: 'Any (0)'})
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TRAFFIC_CLASSES_LIST')
    this.$store.dispatch('Tariffing/GET_TIME_RANGE')
    this.$store.dispatch('Settings/GET_NETFLOW_PROVIDERS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/trafficClasses/main.vue